import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type ListSessionMatchesParams } from '@webapp/modules/accounts-payable/business-logic/interfaces/IReconcileSessionRepository'
import { getCreditCardBillFormData } from '../business-logic/use-cases/GetCreditCardBillFormData'
import { reconcileSessionRepository } from '../data-access/repositories/ReconcileSessionRepository'

const base = ['reconcile-sessions']

// Partial key for command invalidation (match create/delete, item edits).
export const RECONCILE_SESSION_MATCHES_BASE_KEY = [...base, 'matches']

// Partial key for FS-level invalidation after a payment method is created
// (ADR-6 boundary — the vendor feature performs no invalidation).
export const RECONCILE_SESSION_BILL_FORM_DATA_BASE_KEY = [
  ...base,
  'bill-form-data',
]

export const reconcileSessionQueries = {
  matches: (sessionId: number, params: ListSessionMatchesParams = {}) => ({
    queryKey: buildQueryKey([
      ...RECONCILE_SESSION_MATCHES_BASE_KEY,
      sessionId,
      params,
    ]),
    queryFn: () => reconcileSessionRepository.listMatches(sessionId, params),
  }),
  approverChoices: (sessionId: number, approvalChainId: number) => ({
    queryKey: buildQueryKey([
      ...base,
      'approver-choices',
      sessionId,
      approvalChainId,
    ]),
    queryFn: () =>
      reconcileSessionRepository.getApproverChoices(sessionId, approvalChainId),
  }),
  billFormData: (vendorId: number, cardCurrencyId: number) => ({
    queryKey: buildQueryKey([
      ...RECONCILE_SESSION_BILL_FORM_DATA_BASE_KEY,
      vendorId,
      cardCurrencyId,
    ]),
    queryFn: () => getCreditCardBillFormData({ vendorId, cardCurrencyId }),
  }),
}
